import { render, staticRenderFns } from "./ExpandableButton.vue?vue&type=template&id=1a671437&"
import script from "./ExpandableButton.vue?vue&type=script&lang=js&"
export * from "./ExpandableButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableButton.vue?vue&type=style&index=0&id=1a671437&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports